import { ApiResponse } from '@/domain';
import { Collector } from '@/domain/collectors/collector';
import { SaleByOffering, SaleBySeller, SalesSummary, SalesSummaryByOffering } from '@/domain/sellers/sellers';
import { backendApi } from '../backendApi';

export const sellersApi = {
  getAllSellers: (filters?: { status?: string; name?: string; }) =>
    backendApi.get<ApiResponse<Collector[]>>(`/api/v1/sellers`, {
      params: filters,
    }).then((res) => res.data.data),

  getSeller: (id: string) =>
    backendApi.get<ApiResponse<Collector>>(`/api/v1/sellers/${id}`).then((res) => res.data.data),

  createSeller: (data: Partial<Collector>) =>
    backendApi.post<ApiResponse<Collector>>(`/api/v1/sellers`, data).then((res) => res.data.data),

  updateSeller: (id: string, data: Partial<Collector>) =>
    backendApi.put<ApiResponse<Collector>>(`/api/v1/sellers/${id}`, data).then((res) => res.data.data),

  deleteSeller: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/sellers/${id}`).then((res) => res.data.data),

  getSalesSummaryByOffering: (fromDate: Date, toDate?: Date, serviceType?: string, offeringId?: string) =>
    backendApi.get<ApiResponse<SalesSummaryByOffering[]>>(`/api/v1/data/sales/summary/by-offering`, {
      params: { fromDate, toDate, serviceType, offeringId },
    }).then((res) => res.data.data),

  getSalesSummaryBySeller: (fromDate: Date, toDate?: Date, sellerId?: string, serviceType?: string) =>
    backendApi.get<ApiResponse<SalesSummary>>('/api/v1/data/sales/summary/by-seller', {
      params: { fromDate, toDate, sellerId, serviceType },
    }).then((res) => res.data.data),

  getSalesBySeller: (sellerId: string, fromDate: Date, toDate?: Date) =>
    backendApi.get<ApiResponse<SaleBySeller[]>>(`/api/v1/data/sales/sellers/${sellerId}`, {
      params: { fromDate, toDate },
    }).then((res) => res.data.data),

  getSalesByOffering: (offeringId: string, fromDate: Date, toDate?: Date) =>
    backendApi.get<ApiResponse<SaleByOffering[]>>(`/api/v1/data/sales/offerings/${offeringId}`, {
      params: { fromDate, toDate },
    }).then((res) => res.data.data),

}
